import { BehaviorSubject } from 'rxjs';

export const APICONSTANTS = {
    URLAPI: new BehaviorSubject<string>(''),
    ROUTEBC: 'api/bc/',
    ROUTEBCLINE: 'api/bcLigne/',
    ROUTECA1: 'api/ca1/',
    ROUTECA2: 'api/ca2/',
    ROUTEDOCUMENT: 'api/document/',
    ROUTEINTERFACE: 'api/interface/',
    ROUTESOCIETE: 'api/societe/',
    ROUTESITE: 'api/site/',
    ROUTEFOURNISSEUR: 'api/fournisseur/',
    ROUTEBP: 'api/Bp/',
    ROUTECONDREGL: 'api/condRegl/',
    ROUTEMODEREGL: 'api/modeRegl/',
    ROUTEBPLIGNE: 'api/bpLigne/',
    ROUTEUSER: 'api/Utilisateur/',
    ROUTENA: 'api/Na/',
    ROUTECOMP: 'api/Comp/',
    ROUTETYPECOMP: 'api/typeComp/',
    ROUTECGCHARGE: 'api/CgCharge/',
    ROUTEARTICLE: 'api/article/',
    ROUTETVA: 'api/tva/',
    ROUTECYCLEBC: 'api/CycleBc/',
    ROUTECYCLEBP: 'api/CycleBp/',
    ROUTEGOOGLELOGIN: 'api/Account/Google/',
    ROUTECATEGORIE: 'api/categorie/',
    ROUTELIVRAISONBC: 'api/LivraisonBc/',
    ROUTEDROIT: 'api/Droit/',
    ROUTESEUIL: 'api/seuil/',
    ROUTESSDOMAINE: 'api/SsDomaine/',
    ROUTESSFAMILLE: 'api/SsFamille/',
    ROUTEACTIVITE: 'api/activite/',
    ROUTEFAMILLE: 'api/famille/',
    ROUTEDESTINATION: 'api/destination/',
    ROUTEPERIODESAGE: 'api/PeriodeSage/',
    ROUTEPARAMLANDPAGE: 'api/ParamLandpage/',
    ROUTEMAILS: 'api/SendMailsBc/'
};